import { render, staticRenderFns } from "./SuperadminCollectiveAgreements.vue?vue&type=template&id=15c4813c&scoped=true&"
import script from "./SuperadminCollectiveAgreements.vue?vue&type=script&lang=js&"
export * from "./SuperadminCollectiveAgreements.vue?vue&type=script&lang=js&"
import style0 from "./SuperadminCollectiveAgreements.vue?vue&type=style&index=0&id=15c4813c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c4813c",
  null
  
)

export default component.exports